import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootProduct: {
				background: theme.palette.common.white,
				margin: "10px 0px",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6
			},
			images: {
				padding: 16,
				zIndex: 2,
				background: theme.palette.common.white,
				borderRadius: 6,
				"& > img": {
					objectFit: "contain"
				}
			},
			infoProduct: {
				padding: "16px 5px",
				height: 50,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between"
			},
			nameProduct: {
				color: theme.palette.primary.contrastText,
				fontSize: 14
			},
			price: {
				color: theme.palette.grey[50],
				fontSize: 12,
				"& > span": {
					color: theme.palette.primary.contrastText,
					fontWeight: 500,
					fontSize: 13
				}
			}
		}),
	{
		name: "ProductItem",
		index: 1
	}
);

export default useStyles;
